// @flow
import React from 'react';
import classNames from 'classnames';

import Image from 'Components/frameworks/image/Image.jsx';

type FooterTripAdvisorProps = {
  className?: string,
  text?: string,
};

export function FooterTripAdvisor({ className, text }: FooterTripAdvisorProps) {
  if (!text) {
    return null;
  }

  return (
    <div className={classNames(className, 'rtl:text-right')}>
      <span className="align-middle text-xs sm:text-base" data-testid="FooterTripAdvisor-title">
        {text}
      </span>
      <Image
        altMsg="Trip Advisor"
        className="align-middle rtl:ml-2"
        dontChangeAnything
        imageUrl="https://www.tripadvisor.com/img/cdsi/langs/en/tripadvisor_logo_white_340x80-24206-0-en_US.png"
        style={{ width: '8.5rem' }}
      />
    </div>
  );
}
